import { fieldStyle, labelStyle, inputStyle } from '../../constants/general';
import { FormFields } from './FormFields';

export const FieldPreferences = ({ formik }) => {
  return (
    <>
      <div className={fieldStyle}>
        <label htmlFor="formTitle" className={labelStyle}>
          Form Title
        </label>

        <input
          id="formTitle"
          type="text"
          className={inputStyle}
          value={formik.values.formTitle}
          onChange={formik.handleChange}
        />
        {formik.touched.formTitle && formik.errors.formTitle ? (
          <div className="text-error text-sm mt-1">{formik.errors.formTitle}</div>
        ) : null}
      </div>

      <div className={fieldStyle}>
        <label htmlFor="formDescription" className={labelStyle}>
          Form Description
        </label>

        <input
          id="formDescription"
          type="text"
          className={inputStyle}
          value={formik.values.formDescription}
          onChange={formik.handleChange}
        />
      </div>

      <div className={fieldStyle}>
        <FormFields formik={formik} />
      </div>
    </>
  );
};
